import React from 'react';

const AddMemberModal = ({
  show,
  onClose,
  selectedGroup,
  memberForm,
  onMemberFormChange,
  onSubmit,
  users,
  getAvailableUsers, // For regular groups
  memberRoles,
  addMemberMutation,
}) => {
  if (!show || !selectedGroup) return null;

  const availableUsers = getAvailableUsers();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="w-full max-w-md rounded-lg bg-white">
        <div className="p-6">
          <h3 className="mb-4 text-lg font-medium text-gray-900">{`Add Member to ${selectedGroup.name}`}</h3>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Select User</label>
              <select
                name="user_id"
                value={memberForm.user_id}
                onChange={onMemberFormChange}
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select a user</option>
                {availableUsers.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.first_name} {user.last_name} ({user.email})
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Role in Group</label>
              <select
                name="role_in_group"
                value={memberForm.role_in_group}
                onChange={onMemberFormChange}
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {memberRoles.map((role) => (
                  <option key={role} value={role}>
                    {role.replace('_', ' ')}
                  </option>
                ))}
              </select>
            </div>

            {/* Admin promotions moved to Admin page */}

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 rounded bg-gray-200 px-4 py-2 font-semibold text-gray-900 transition-colors hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`flex-1 rounded bg-blue-500 px-4 py-2 font-semibold text-white transition-colors hover:bg-blue-600 disabled:bg-blue-300`}
                disabled={addMemberMutation.isLoading || !memberForm.user_id}
              >
                {addMemberMutation.isLoading ? 'Adding...' : 'Add Member'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddMemberModal;
